import { render, staticRenderFns } from "./ForceDirectedGraph.vue?vue&type=template&id=754ccd10&scoped=true&"
import script from "./ForceDirectedGraph.vue?vue&type=script&lang=js&"
export * from "./ForceDirectedGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754ccd10",
  null
  
)

export default component.exports